import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-container">
      <h1 className="header">Tuqui Tuqui</h1>
    </div>
  );
};

export default Header;
